const choices = {
    purchase: 'Achat',
    donation: 'Donation',
    inheritance: 'Succession',
};

export default choices;
